export default "__VITE_ASSET__CnJGEvC2__"